import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { OfferService } from '../../../offer/offer.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NewComponent } from '../../../offer/new/new.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../../common/services/reporting.service';
declare var require;
const Swal = require('sweetalert2');

@Component({
    selector: 'portal-offer-new',
    templateUrl: './portal-offer-new.component.html'
})
export class PortalOfferNewComponent implements OnInit {
    @ViewChild('offerNewComponet', null) offerNewComponet: NewComponent;
    public insurancedXPortal: string;
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,
                public apiService: ApiService,
                private toastrService: ToastrService,
                private offerService: OfferService,
                private spinner: NgxSpinnerService,
                private router: Router,
                private route: ActivatedRoute,
                private reportingService: ReportingService) {

        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};
        if (browserWindowEnv.hasOwnProperty('insurancedXPortal')) {
            this.insurancedXPortal = window['__env']['insurancedXPortal'];
        }
    }

    ngOnInit() {
  
    }

    directPayClick(event) {

        if (this.insurancedXPortal == "true") {

            //validate for transform
            if (!this.offerNewComponet.transformCheck(true)) {
                this.spinner.hide();
                return;
            }

            //save quote if it is not saved
            if (!this.offerService.offerHeaderKey && !this.offerService.versionNo) {
                this.spinner.show();
                this.apiService.post("Api/QuoteApi/SaveHeader/", this.offerNewComponet.wizard).subscribe((res: any) => {
                    this.apiService.post("Api/QuoteApi/Save/", this.offerNewComponet.wizard).subscribe((res: any) => {
                        this.toastrService.success(this.translate.instant("Quote No. " + res.ExternalCode + " has been saved successfully"));
                        this.reportingService.printAutomaticReportsInQueueByProcess(21, this.offerNewComponet.wizard.ProcessCode,
                            this.offerNewComponet.wizard.ProductCode, [res.Key], [res.versionNo]);
                        this.offerService.offerHeaderKey = res.Key;
                        this.offerService.versionNo = res.versionNo;
                        this.offerNewComponet.offerexternalcde = res.ExternalCode;
                        this.offerNewComponet.wizard.OfferHeaderKey = res.Key;
                        this.offerNewComponet.wizard.VersionNo = res.versionNo;
                        this.offerNewComponet.wizard.LockedInd = "N";
                        //intitate payment
                        if (!this.offerNewComponet.wizard.IsAcceptWithoutPayment)
                            this.intitateDirectPayment();
                        else
                            this.initiatePolicyTransform({});
                    });
                });

                this.spinner.hide();
            }
            else {
                if (!this.offerNewComponet.wizard.IsAcceptWithoutPayment)
                    this.intitateDirectPayment();
                else
                    this.initiatePolicyTransform({});
            }
        }
    }

    intitateDirectPayment() {
        try {
            //initiate payment process
            let lightbox = window["Lightbox"]
            if (lightbox == null) {
                this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
                return;
            }

            this.apiService.post("Api/WebUserAPI/InitDirectPayment/",
                {
                    OfferHeaderKey: this.offerService.offerHeaderKey,
                    VersionNo: this.offerService.versionNo
                }).subscribe((result: any) => {

                    if (result) {
                        let lightbox = window["Lightbox"]
                        if (lightbox == null) {
                            this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
                            return;
                        }

                        //var discountedTrxnAmt;
                        //if (Object.keys(this.offerService.appliedDiscount).length === 0) {
                        //    discountedTrxnAmt = result.AmountTrxn;
                        //}
                        //else {
                        //    if (this.offerService.appliedDiscount.PercentageIndicator) {
                        //        discountedTrxnAmt = Math.round((result.AmountTrxn - ((this.offerService.appliedDiscount.AmountValue / 100) * result.AmountTrxn)) * 1000) / 1000;//round 3 places;
                        //    }
                        //    else {
                        //        discountedTrxnAmt = Math.round((result.AmountTrxn - this.offerService.appliedDiscount.AmountValue) * 1000) / 1000;//round 3 places;
                        //    }
                        //}

                        lightbox.Checkout.configure = {
                            "MID": result.MID,
                            "TID": result.TID,
                            "AmountTrxn": result.AmountTrxn,
                            "MerchantReference": result.MerchantReference,
                            "TrxDateTime": result.TrxDateTime,
                            "SecureHash": result.SecureHash,
                            completeCallback: function (data) {
                                var event = new CustomEvent('onCompleteCallback', { detail: { "data": data } });
                                window.dispatchEvent(event);
                            },
                            errorCallback: function (error) {
                                var event = new CustomEvent('onErrorCallback', {});
                                window.dispatchEvent(event);
                            },
                            cancelCallback: function () {
                                var event = new CustomEvent('onCancelCallback', {});
                                window.dispatchEvent(event);
                                //this.completeCallback({}); // only for test
                            }
                        };
                        lightbox.Checkout.showLightbox();
                    }
                });
        } catch {
            this.toastrService.error(this.translate.instant("Can't process payment now.Please retry later."));
        }
    }

    @HostListener('window:onErrorCallback', ['$event.detail'])
    errorCallback(detail) {
        this.spinner.hide();
    }

    @HostListener('window:onCancelCallback', ['$event.detail'])
    cancelCallback(detail) {
        this.spinner.hide();
    }

    @HostListener('window:onCompleteCallback', ['$event.detail'])
    completeCallback(detail) {
        let lightbox = window["Lightbox"]
        lightbox.Checkout.closeLightbox();
        this.toastrService.info(this.translate.instant("Payment successful, creating Policy. Please do not close/refresh browser."));
        this.spinner.show();

        this.initiatePolicyTransform(detail);
        
    }

    initiatePolicyTransform(detail) {

        var model = {
            "Wizard": this.offerNewComponet.wizard,
            "Account": { saveCard: false },
            "Response": JSON.stringify(detail.data)
        }
        this.router.navigate(["../../Home"], { relativeTo: this.route });
        this.spinner.show();
        this.apiService.post("Api/WebUserApi/DirectPayment/", model).subscribe((data: any) => {
            this.spinner.hide();
            var gatewayResponse = "";
            var message = "";
            if (data && data.PaymentResponseCode && data.PaymentResponseCode != "0") {
                gatewayResponse = this.translate.instant("Failure Reason") + ":" + data.PaymentResponseCode + " " + data.PaymentResponseMessage;
                Swal.fire({ text: gatewayResponse, type: 'danger' });
            }
            if (data == null) {
                message = this.translate.instant('Unable to process your request. Please retry.');
                Swal.fire({ text: message, type: 'danger' });
            }
            else if (data.AllocatedInd == 'Y') {
                var message = 'The policy has been successfully issued, policy number is 991. The payment processed succesfully, receipt number is 992. Referred policy documents have been sent to your email.';
                message = this.translate.instant(message);
                message = message.replace("991", data.PolExtCode).replace("992", data.ReceiptNumber);
                Swal.fire({ text: message, type: 'success' });

                this.reportingService.printProcess(this.offerNewComponet.wizard.ProcessCode,
                    this.offerNewComponet.wizard.ProductCode,
                    data.PolicyKey, 0, 31);
            }
            else {
                if (data.PaymentResponseCode == "0") //error in allocation or acceptance     
                {
                    message = 'Payment is successful. Your policy is not yet In Force. Please contact helpdesk with reference no:991';
                    message = this.translate.instant(message);
                    message = message.replace("991", data.PolExtCode);
                    Swal.fire({ text: message, type: 'info' });
                }
                else if (data.PaymentResponseCode != "") {
                    message = 'Unable to process the payment. Please contact helpdesk with reference no:991. 992';
                    message = this.translate.instant(message);
                    message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                    Swal.fire({ text: message, type: 'danger' });
                }
                else if (data.PaymentResponseCode == "") //not reached till payment
                {
                    if (data.PolExtCode == "") //not created quote
                    {
                        if (data.OfferExtCode == "") {
                            message = 'Unable to process your request. Please retry.';
                            message = this.translate.instant(message);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                        else //offer created       
                        {
                            message = 'Unable to process the payment. Please contact helpdesk. Your offer reference number is 991. 992';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                    }
                    else //quote created
                    {
                        if (!this.offerService.wizard.IsAcceptWithoutPayment &&
                            (data.IntegrityCheckStatusCode == "1" || data.IntegrityCheckStatusCode == "2" || data.IntegrityCheckStatusCode == "")) {
                            message = 'Unable to process the payment. Please contact helpdesk. Your quote reference number is 991. 992';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                        if (this.offerService.wizard.IsAcceptWithoutPayment &&
                            (data.IntegrityCheckStatusCode == "1" || data.IntegrityCheckStatusCode == "2" || data.IntegrityCheckStatusCode == "")) {
                            message = 'The policy No. is 991 to process the payment please contact the helpdesk.';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode).replace("992", gatewayResponse);
                            Swal.fire({ text: message, type: 'danger' });

                            this.reportingService.printProcess(this.offerNewComponet.wizard.ProcessCode,
                                this.offerNewComponet.wizard.ProductCode,
                                data.PolicyKey, 0, 31);
                        }
                        else {
                            message = 'Policy integrity check failed. Please contact helpdesk. Your quote reference number is 991';
                            message = this.translate.instant(message);
                            message = message.replace("991", data.PolExtCode);
                            Swal.fire({ text: message, type: 'danger' });
                        }
                    }
                }
            }
        }, (reason) => {
            this.spinner.hide();
        });
    }

}
